/* eslint-disable react/jsx-closing-bracket-location */
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Alert from '../../Common/AlertContainer';
import { commonStyle } from '../../Common/CommonStyle';
import Error from '../../Common/Error';
import MobileFooter from '../../Common/Profile/MobileFooter';
import { hot } from 'react-hot-loader';

const APPLICATION_EXCEPTION = window.ApplicationException;

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_error: null,
			_errorFromEdit: '',
			_isResendingOtp: false,
			_isOptSubmitBtnLoaderOn: false,
			mobile: {
				otp: ''
			},
			email: {
				otp: ''
			},
			_alert: {
				_show: false,
				_message: '',
				_severity: ''
			}
		};
	}

	otpChangeHandler(otp, type) {
		const value = otp.target.value.replace(/\D/g, '');

		if (value.length <= 6) {
			const state = {
				...this.state
			};
			state[type].otp = value;
			this.setState({
				state,
				_error: null
			});
		}
	}

	getOtp(type) {
		const blocks = {
			email: this.state.email,
			mobile: this.state.mobile
		};
		return blocks[type].otp.toString();
	}

	resetOtpForm = () => {
		this.setState({
			mobile: {
				otp: ''
			},
			email: {
				otp: ''
			}
		});
	};

	onsubmitFormHandler = async e => {
		e.preventDefault();
		const otp = this.getOtp(this.props.mode);
		if (otp.length !== 6) {
			this.setState({
				_error: 'error.message.invalid_otp'
			});
			return false;
		}
		this.setState({
			_isOptSubmitBtnLoaderOn: true
		});
		try {
			const response = await this.props.verifyOtp(otp);
			this.setState({
				_isOptSubmitBtnLoaderOn: false
			});
			if (this.props.fromEditContact && !response.status) {
				this.setState({
					_errorFromEdit: response.data
				});
			}
		} catch (err) {
			console.log(err);
			if (err.code === APPLICATION_EXCEPTION.CODE_MIS_MATCH_EXCEPTION) {
				this.resetOtpForm();
				this.setState({
					_error: 'error_message.invalid_code',
					_isOptSubmitBtnLoaderOn: false
				});
			}
		}
	};

	resendOtp = async () => {
		this.setState({
			_isResendingOtp: true
		});
		const message =
			this.props.mode === 'mobile'
				? 'signin.code_sent_successfully_mobile'
				: 'signin.code_sent_successfully_email';
		try {
			await this.props.resendOtp();
			await this.showAlert(true, 'success', message);
			this.setState({
				_isResendingOtp: false
			});
		} catch (err) {
			await this.showAlert(true, 'error', 'error_message.something_went_wrong');
			this.setState({
				_isResendingOtp: false
			});
		}
	};

	showAlert = async (show, severity, message) => {
		const alert = {
			_show: show,
			_message: message,
			_severity: severity
		};
		await this.setState({
			_alert: alert
		});
	};

	hideAlert = async () => {
		const alert = {
			_show: false,
			_message: '',
			_severity: ''
		};
		await this.setState({
			_alert: alert
		});
	};

	componentDidMount() {
		this.resetOtpForm();
	}

	render() {
		const { classes } = this.props;
		const { t } = this.props;
		return (
			<Container component="main" maxWidth="md" className="kyc_otp_container">
				<CssBaseline />
				<Paper className={classes.paper}>
					<Grid id="full-wdith" item sm={8} xs={12} md zeroMinWidth>
						<div>
							<div className={classes.paper} id="kyc_otp_auth">
								<Typography component="h4" gutterBottom variant="h5">
									{t('signin.text_for_otp_screen')}{' '}
									{this.props.mode === 'mobile'
										? t('label.mobile_phone')
										: t('label.email').toUpperCase()}{' '}
									:
								</Typography>
								<Typography align="center" component="p">
									{t('signin.want_to_make_sure')}
								</Typography>
								<form
									noValidate
									onSubmit={this.onsubmitFormHandler}
									style={{
										width: '185px'
									}}>
									{this.props.mode === 'mobile' ? (
										<TextField
											className="text-center kyc_otp_input_code"
											id="outlined-basic"
											label={t('label.code')}
											margin="normal"
											placeholder="123456"
											onChange={otp => this.otpChangeHandler(otp, 'mobile')}
											value={this.state.mobile.otp}
											variant="outlined"
										/>
									) : (
										<TextField
											className="text-center kyc_otp_input_code"
											id="outlined-basic"
											label={t('label.code')}
											margin="normal"
											placeholder="123456"
											onChange={otp => this.otpChangeHandler(otp, 'email')}
											value={this.state.email.otp}
											variant="outlined"
										/>
									)}
									{/* <div className={classes.blockdiv}>
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											size="medium"
											type="submit"
											variant="extended">
											{t('buttons.submit')} &nbsp;
											{this.state._isOptSubmitBtnLoaderOn ? (
												<CircularProgress disableShrink size={18} />
											) : (
												<ArrowForwardIcon />
											)}
										</Fab>
									</div> */}
								</form>
								<Error
									text={
										this.state._errorFromEdit !== ''
											? this.state._errorFromEdit
											: t(this.state._error)
									}
								/>
								<Typography component="h4" gutterBottom className="receive_code" variant="h5">
									{t('signin.didnt_recieve_code')}
								</Typography>
								<Link
									href="#"
									className="resend_code"
									onClick={e => {
										e.preventDefault();
										this.resendOtp();
									}}
									style={{
										color: this.state.allowResendOtp ? '#27B88D' : 'grey',
										pointerEvents: this.state.allowResendOtp ? '' : 'none'
									}}
									variant="body2">
									{this.state._isResendingOtp ? t('label.sending') : t('label.send_code_again')}
								</Link>
							</div>
						</div>
					</Grid>
				</Paper>
				<Alert
					message={t(this.state._alert._message)}
					onClose={this.hideAlert}
					severity={this.state._alert._severity}
					show={this.state._alert._show}
				/>
				<form noValidate onSubmit={this.onsubmitFormHandler} className="otp_footer">
					<Grid sm={8} xs={12} item>
						<MobileFooter
							loading={
								this.state._isOptSubmitBtnLoaderOn ? (
									<CircularProgress disableShrink size={18} className="ml-2" />
								) : null
							}
							hasNext={true}
							htmlType="Submit"
							className="kyc_otp"
							onClick={this.props.handleBackFromOtp}
							textButtonContinue={this.state._isOptSubmitBtnLoaderOn ? null : 'SUBMIT'}
						/>
					</Grid>
				</form>
			</Container>
		);
	}
}

export default hot(module)(withStyles(commonStyle)(withTranslation()(index)));
